import { HttpErrorResponse } from "@angular/common/http";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "ionic-angular";
import moment from "moment";
import { PayersService } from "../../../../providers/payers-service/payers.service";
import { NgbCustomParserFormatter } from "../../../common/date-picker/ngb-custom-parser-formatter";
import {
  ContractPeriod,
  CountyData,
  PalliativeVisitPayerRates,
  PalliativeVisitRate,
} from "../models";

@Component({
  selector: "palliative-visits",
  templateUrl: "./palliative-visits.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatesPalliativeVisits),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RatesPalliativeVisits),
      multi: true,
    },
    { provide: NgbDateParserFormatter, useClass: NgbCustomParserFormatter },
  ],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class RatesPalliativeVisits implements OnInit, OnDestroy {
  private statesList: string[] = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District of Columbia",
    "Florida",
    "Georgia",
    "Hawaii/Guam",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Puerto Rico",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virgin Islands",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  contractPeriodsOptions: ContractPeriod[];
  _saveEnabled: boolean = false;
  validForm: boolean = true;
  dateFormat: string = "YYYY-MM-DD";
  dateUIFormat: string = "MM/DD/YYYY";
  currentContractPeriod: any;

  @Input() isActive: boolean = false;
  @Input() currentPayer: any;
  @Output() onCanceled = new EventEmitter<any>();
  @Output() onRatesSaved = new EventEmitter<any>();

  showRatesSection: boolean = false;

  showPalliativeHomeVisitCodes: boolean = false;
  showPalliativeNursingHomeVisitCodes: boolean = false;
  showPalliativeHospitalPatientVisitCodes: boolean = false;
  showPalliativeOtherBillingCodes: boolean = false;

  previousContractPeriod: any;

  states: string[] = [];
  counties: CountyData[] = [];
  selectedState: string = "";
  selectedCounty: string = "";
  selectedCountyData: CountyData | null = null;
  hasUnsavedChanges: boolean = false;
  lastSelectedState: string = "";
  lastSelectedCounty: string = "";

  @ViewChild("stateSelect") stateSelect: any;
  @ViewChild("countySelect") countySelect: any;

  palliativeHomeVisitCodesSetup: any = [
    {
      BillingCode: "99341",
      Description: "Home New Patient Visit Basic",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99342",
      Description: "Home New Patient Visit Low",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99344",
      Description: "Home New Patient Visit Mod Comp",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99345",
      Description: "Home New Patient Visit High",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99347",
      Description: "Home Est Patient Visit Basic",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99348",
      Description: "Home Est Patient Visit Low",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99349",
      Description: "Home Est Patient Visit Moderate",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99350",
      Description: "Home Est Patient Visit High",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
  ];

  palliativeNursingHomeVisitCodesSetup: any = [
    {
      BillingCode: "99304",
      Description: "Nursing Home New Patient Visit Low",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99305",
      Description: "Nursing Home New Patient Visit Moderate",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99306",
      Description: "Nursing Home New Patient Visit High",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99307",
      Description: "Nursing Home Est Patient Low",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99308",
      Description: "Nursing Home Est Patient Moderate",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99309",
      Description: "Nursing Home Est Patient Medium",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99310",
      Description: "Nursing Home Est Patient High",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
  ];

  palliativeHospitalPatientVisitCodesSetup: any = [
    {
      BillingCode: "99221",
      Description: "Initial Hospital Care",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99222",
      Description: "Initial Hospital Care",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99223",
      Description: "Initial Hospital Care",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99231",
      Description: "Subsequent Hospital Care",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99232",
      Description: "Subsequent Hospital Care",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99233",
      Description: "Subsequent Hospital Care",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "98016",
      Description: "Brief Patient Check In/ Phone Call 5-10 Min",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
  ];

  palliativeOtherBillingCodesSetup: any = [
    {
      BillingCode: "99497",
      Description: "Advanced Care Planning 30 Min",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99498",
      Description: "Advanced Care Planning Additional 30 min",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "G2212",
      Description: "Prolonged Outpt/office visit",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "G0316",
      Description: "Prolonged Inpatient 15 min",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "G0317",
      Description: "Prolonged Nursing Facility 15 min",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "G0318",
      Description: "Prolonged Home/Residence 15 min",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99406",
      Description: "Smoking Cessation 3-10 min",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99407",
      Description: "Smoking Cessation > 10 min",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99202",
      Description: "Office or Outpatient Visit, New Patient (5-10 Minutes)",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99215",
      Description:
        "Office or Outpatient Visit, Established Patient (21-30 Minutes)",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99490",
      Description: "Chronic Care Management 20 Minutes",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99495",
      Description: "Transitional Care 14 Day Discharge",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
    {
      BillingCode: "99496",
      Description: "Transitional Care 7 day Discharge",
      Rate: "",
      M1: "",
      M2: "",
      M3: "",
      M4: "",
      Error: "",
      Disabled: false,
    },
  ];

  constructor(
    public modalCtrl: ModalController,
    private payersService: PayersService,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private cdr: ChangeDetectorRef
  ) {
    if (this.currentContractPeriod == null) {
      this.currentContractPeriod = this.emptyContractPeriod();
    }
  }

  ngOnChanges(changes) {
    this.contractPeriodsOptions = [];
    this.currentContractPeriod = this.emptyContractPeriod();
    this._saveEnabled = false;
    this.hasUnsavedChanges = false;
    if (this.isActive) {
      this.loadOptions();
    }
  }

  ngOnDestroy(): void {
    this.currentContractPeriod = this.emptyContractPeriod();
    this._saveEnabled = false;
    this.hasUnsavedChanges = false;
  }

  ngOnInit() {
    this.states = this.statesList;
  }

  onPeriodChanged() {
    this.getPayerContractPeriods(false);
    this.currentContractPeriod = null;
  }

  emptyContractPeriod() {
    return null;
  }

  loadOptions(): void {
    if (
      this.currentPayer &&
      this.currentPayer.payerType &&
      this.currentPayer.payerType.toUpperCase() === "MEDICARE"
    ) {
      return;
    }

    let addNewContractPeriodOption: ContractPeriod = {
      id: 0,
      name: "Add New",
      value: "Add New",
      effectiveDate: "",
      expiredDate: "",
    };
    this.contractPeriodsOptions = [
      addNewContractPeriodOption,
      ...this.contractPeriodsOptions,
    ];
  }

  saveVisitRates() {
    this.palliativeHomeVisitCodesSetup = this.setEmptyRatesToDefaultValue(
      this.palliativeHomeVisitCodesSetup
    );
    this.palliativeNursingHomeVisitCodesSetup =
      this.setEmptyRatesToDefaultValue(
        this.palliativeNursingHomeVisitCodesSetup
      );
    this.palliativeHospitalPatientVisitCodesSetup =
      this.setEmptyRatesToDefaultValue(
        this.palliativeHospitalPatientVisitCodesSetup
      );
    this.palliativeOtherBillingCodesSetup = this.setEmptyRatesToDefaultValue(
      this.palliativeOtherBillingCodesSetup
    );

    let payerRates = this.mapNewPalliativeVisitRate(
      [],
      this.currentContractPeriod.effectiveDate,
      this.currentContractPeriod.expiredDate
    );
    payerRates = this.mapRatesValuesToSave(payerRates);
    this.saveNewPayerContractPeriod(
      payerRates,
      "Rates saved successfully.",
      true
    );
  }

  mapRatesValuesToSave(palliativeVisitPayerRates: PalliativeVisitPayerRates) {
    const forEachMap = (formRate) => {
      let rate: PalliativeVisitRate = {
        BillingCode: formRate.BillingCode,
        Description: formRate.Description,
        Rate: Number(formRate.Rate),
        M1: formRate.M1,
        M2: formRate.M2,
        M3: formRate.M3,
        M4: formRate.M4,
      };
      palliativeVisitPayerRates.rates.push(rate);
    };

    this.palliativeHomeVisitCodesSetup.forEach(forEachMap);
    this.palliativeNursingHomeVisitCodesSetup.forEach(forEachMap);
    this.palliativeHospitalPatientVisitCodesSetup.forEach(forEachMap);
    this.palliativeOtherBillingCodesSetup.forEach(forEachMap);

    return palliativeVisitPayerRates;
  }

  setEmptyRatesToDefaultValue(ratesArray) {
    ratesArray.map((rate) => {
      rate.Rate = rate.Rate == "" ? "0.00" : rate.Rate;
      return rate;
    });
    return ratesArray;
  }

  cancel() {
    this.onCanceled.emit(true);
  }

  checkValidForm() {
    this.validForm = true;
    this.palliativeHomeVisitCodesSetup.forEach((visitRate) => {
      if (visitRate.Error != "") this.validForm = false;
    });
    this.palliativeNursingHomeVisitCodesSetup.forEach((visitRate) => {
      if (visitRate.Error != "") this.validForm = false;
    });
    this.palliativeHospitalPatientVisitCodesSetup.forEach((visitRate) => {
      if (visitRate.Error != "") this.validForm = false;
    });
    this.palliativeOtherBillingCodesSetup.forEach((visitRate) => {
      if (visitRate.Error != "") this.validForm = false;
    });
  }

  setPalliativeHomeVisitCodesSetup(value) {
    this.palliativeHomeVisitCodesSetup = value;
    this.checkValidForm();
    this.markDirtyAndUpdateSaveEnabled();
  }

  setPalliativeNursingHomeVisitCodesSetup(value) {
    this.palliativeNursingHomeVisitCodesSetup = value;
    this.checkValidForm();
    this.markDirtyAndUpdateSaveEnabled();
  }

  setPalliativeHospitalPatientVisitCodesSetup(value) {
    this.palliativeHospitalPatientVisitCodesSetup = value;
    this.checkValidForm();
    this.markDirtyAndUpdateSaveEnabled();
  }

  setPalliativeOtherBillingCodesSetup(value) {
    this.palliativeOtherBillingCodesSetup = value;
    this.checkValidForm();
    this.markDirtyAndUpdateSaveEnabled();
  }

  private markDirtyAndUpdateSaveEnabled() {
    this.hasUnsavedChanges = true;
    this.updateSaveEnabledForRates();
  }

  private updateSaveEnabledForRates() {
    const hasRates =
      this.palliativeHomeVisitCodesSetup.some((r) => r.Rate && r.Rate !== "") ||
      this.palliativeNursingHomeVisitCodesSetup.some(
        (r) => r.Rate && r.Rate !== ""
      ) ||
      this.palliativeHospitalPatientVisitCodesSetup.some(
        (r) => r.Rate && r.Rate !== ""
      ) ||
      this.palliativeOtherBillingCodesSetup.some(
        (r) => r.Rate && r.Rate !== ""
      );
    this._saveEnabled = !!(
      this.hasUnsavedChanges &&
      this.selectedState &&
      this.selectedCounty &&
      this.currentContractPeriod &&
      this.validForm
    );
  }

  set saveEnabled(value: boolean) {
    this._saveEnabled = value;
  }

  get saveEnabled() {
    return this._saveEnabled;
  }

  onCollapseClicked(event, tableName) {
    switch (tableName) {
      case "palliativeHomeVisitCodes":
        this.showPalliativeHomeVisitCodes = event.isOpen;
        break;
      case "palliativeNursingHomeVisitCodes":
        this.showPalliativeNursingHomeVisitCodes = event.isOpen;
        break;
      case "palliativeHospitalPatientVisitCodes":
        this.showPalliativeHospitalPatientVisitCodes = event.isOpen;
        break;
      case "palliativeOtherBillingCodes":
        this.showPalliativeOtherBillingCodes = event.isOpen;
        break;
    }
  }

  async onContractPeriodChange(event: any) {
    if (!event) {
      this.currentContractPeriod = this.emptyContractPeriod();
      this.saveEnabled = false;
      this.previousContractPeriod = this.currentContractPeriod;
      this.clearContractPeriodRates();
      this.setRatesDisabledToEdit();
      this.showRatesSection = false;
      this.cdr.detectChanges();
      return;
    }
    if (event.value == "Add New") {
      this.addNewContractPeriod();
    } else {
      this.currentContractPeriod = {
        id: event.id,
        name: event.name,
        value: event.value,
        expiredDate: event.expiredDate,
        effectiveDate: event.effectiveDate,
      };
      this.loadRatesForSelectedCounty();
      this.previousContractPeriod = this.currentContractPeriod;
      this.saveEnabled = false;
    }
  }

  onContractPeriodClear(event: any) {
    this.contractPeriodsOptions = this.contractPeriodsOptions.filter(
      (option) => option.id != 0
    );
    this.loadOptions();
    this.currentContractPeriod = this.emptyContractPeriod();
    this.clearContractPeriodRates();
    this.setRatesDisabledToEdit();
    this.showRatesSection = false;
    this.cdr.detectChanges();
    this._saveEnabled = false;
    this.hasUnsavedChanges = false;
  }

  addNewContractPeriod() {
    let minDate: moment.Moment = moment("2023-09-30", this.dateFormat);
    this.contractPeriodsOptions.forEach((contractPeriod) => {
      let periodStart = moment(contractPeriod.effectiveDate);
      if (periodStart.isAfter(minDate)) {
        minDate = periodStart;
      }
    });

    let contractPeriodModal = this.modalCtrl.create(
      "ContractPeriodModalComponent",
      { minDateFormat: minDate },
      { cssClass: "contract-period-modal" }
    );

    contractPeriodModal.onDidDismiss((data) => {
      if (data) {
        let newOption = this.formatContractPeriodModel(data);
        let contractPeriods = this.contractPeriodsOptions.filter(
          (contract) => contract.value != "Add New"
        );
        if (
          contractPeriods.length === 0 ||
          newOption.effectiveDate >
            this.getMostRecentContractPeriod(contractPeriods).effectiveDate
        ) {
          this.saveNewContractPeriodOption(newOption);
        } else {
          this.showAlert({
            title: "Error",
            message:
              "Contract period’s effective date can’t be before or equal to the active period’s date.",
          });
          this.onNewPeriodCanceled();
        }
      } else {
        this.onNewPeriodCanceled();
      }
    });
    contractPeriodModal.present();
  }

  onNewPeriodCanceled() {
    const hasValidPrevious =
      !!this.previousContractPeriod &&
      Array.isArray(this.contractPeriodsOptions) &&
      this.contractPeriodsOptions.some(
        (opt) =>
          opt &&
          this.previousContractPeriod &&
          (opt.value === this.previousContractPeriod.value ||
            opt.effectiveDate === this.previousContractPeriod.effectiveDate)
      );

    this.currentContractPeriod = hasValidPrevious
      ? this.previousContractPeriod
      : this.emptyContractPeriod();
    this.cdr.detectChanges();
  }

  saveNewContractPeriodOption(newOption) {
    this.contractPeriodsOptions = [newOption, ...this.contractPeriodsOptions];
    this.currentContractPeriod = newOption;
    this.clearContractPeriodRates();
    this.removeNewContractPeriodOption();
    this.hasUnsavedChanges = false;
    this.updateSaveEnabledForRates();
    this.showRatesSection = true;
  }

  removeNewContractPeriodOption() {
    this.contractPeriodsOptions = this.contractPeriodsOptions.filter(
      (option) => option.value != "Add New"
    );
  }

  formatContractPeriodModel(period: any): ContractPeriod {
    let newContractPeriod = moment(new Date(period)).format(this.dateUIFormat);
    let newEffectiveDate = moment(new Date(period)).format(this.dateFormat);
    return {
      id: 0,
      name: newContractPeriod,
      value: newContractPeriod,
      effectiveDate: newEffectiveDate,
      expiredDate: null,
    };
  }

  getPayerContractPeriods(firstLoad) {
    let spinnerText = "Loading Contract Periods";

    const spinner = this.loadingCtrl.create({
      content: spinnerText,
    });
    spinner.present();

    const localityCode = this.selectedCountyData
      ? this.selectedCountyData.code
      : "";

    this.payersService
      .getPayerRatesPeriods(
        this.currentPayer.payerId,
        "PALLIATIVE",
        null,
        this.currentPayer.payerType,
        localityCode
      )
      .pipe()
      .take(1)
      .subscribe((response) => {
        spinner.dismiss();
        let previousContractPeriods: ContractPeriod[] = [];
        if (response !== null) {
          let contractPeriod = Object.values(response);
          let count = 1;
          contractPeriod.forEach((period) => {
            let periodStart = moment(period.start);
            let name = periodStart.format(this.dateUIFormat);
            if (period.end && period.end != "") {
              name =
                name + " - " + moment(period.end).format(this.dateUIFormat);
            }
            let newPeriod = {
              id: count,
              name: name,
              value: periodStart.format(this.dateUIFormat),
              effectiveDate: periodStart.format(this.dateFormat),
              expiredDate: period.end
                ? moment(period.end).format(this.dateFormat)
                : "",
            };

            previousContractPeriods.push(newPeriod);
            count++;
          });
        }
        this.contractPeriodsOptions = previousContractPeriods.sort(
          (a, b) =>
            new Date(b.effectiveDate).getTime() -
            new Date(a.effectiveDate).getTime()
        );
        this.loadOptions();
      });
  }

  getMostRecentContractPeriod(contractPeriods) {
    return contractPeriods.sort(
      (a, b) =>
        new Date(b.effectiveDate).getTime() -
        new Date(a.effectiveDate).getTime()
    )[0];
  }

  clearContractPeriodRates() {
    this.palliativeHomeVisitCodesSetup = this.clearPalliativeSetup(
      this.palliativeHomeVisitCodesSetup
    );
    this.palliativeNursingHomeVisitCodesSetup = this.clearPalliativeSetup(
      this.palliativeNursingHomeVisitCodesSetup
    );
    this.palliativeHospitalPatientVisitCodesSetup = this.clearPalliativeSetup(
      this.palliativeHospitalPatientVisitCodesSetup
    );
    this.palliativeOtherBillingCodesSetup = this.clearPalliativeSetup(
      this.palliativeOtherBillingCodesSetup
    );
    this.hasUnsavedChanges = false;
  }

  clearPalliativeSetup(ratesArray) {
    const isMedicare =
      this.currentPayer &&
      this.currentPayer.payerType &&
      this.currentPayer.payerType.toUpperCase() === "MEDICARE";

    ratesArray.map((rate) => {
      rate.Rate = "";
      rate.M1 = "";
      rate.M2 = "";
      rate.M3 = "";
      rate.M4 = "";
      rate.Error = "";
      rate.Disabled = isMedicare;
      return rate;
    });
    return ratesArray;
  }

  mapContractPeriodRates(ratesData) {
    const isMedicare =
      this.currentPayer &&
      this.currentPayer.payerType &&
      this.currentPayer.payerType.toUpperCase() === "MEDICARE";

    const forEachMap = (item) => {
      const match = Object.values(ratesData.rates).find(
        (rateObj) => rateObj["BillingCode"] === item.BillingCode
      );
      if (match) {
        item.Rate = this.formatToTwoDecimals(Number(match["Rate"]));
        item.M1 = match["M1"];
        item.M2 = match["M2"];
        item.M3 = match["M3"];
        item.M4 = match["M4"];
        item.Error = "";
        item.Disabled = isMedicare;
      } else {
        item.Rate = this.formatToTwoDecimals(0);
      }
    };

    if (ratesData && ratesData.rates && ratesData.rates.length > 0) {
      this.palliativeHomeVisitCodesSetup.forEach(forEachMap);
      this.palliativeNursingHomeVisitCodesSetup.forEach(forEachMap);
      this.palliativeHospitalPatientVisitCodesSetup.forEach(forEachMap);
      this.palliativeOtherBillingCodesSetup.forEach(forEachMap);
    }
  }

  setRatesDisabledToEdit() {
    this.palliativeHomeVisitCodesSetup = this.palliativeHomeVisitCodesSetup.map(
      (option) => {
        option.Disabled = true;
        return option;
      }
    );

    this.palliativeNursingHomeVisitCodesSetup =
      this.palliativeNursingHomeVisitCodesSetup.map((option) => {
        option.Disabled = true;
        return option;
      });

    this.palliativeHospitalPatientVisitCodesSetup =
      this.palliativeHospitalPatientVisitCodesSetup.map((option) => {
        option.Disabled = true;
        return option;
      });

    this.palliativeOtherBillingCodesSetup =
      this.palliativeOtherBillingCodesSetup.map((option) => {
        option.Disabled = true;
        return option;
      });
  }

  formatToTwoDecimals(num: number): string {
    return num.toFixed(2);
  }

  saveNewPayerContractPeriod(
    palliativeVisitRatesData: PalliativeVisitPayerRates,
    saveMessage: string,
    saveRate: boolean
  ) {
    if (this.currentPayer) {
      let spinnerText = "Saving Palliative Visit Rates";

      const spinner = this.loadingCtrl.create({
        content: spinnerText,
      });
      spinner.present();
      this.payersService
        .postSavePayerRates(palliativeVisitRatesData)
        .pipe()
        .take(1)
        .subscribe(
          () => {
            spinner.dismiss();
            this.contractPeriodsOptions = [];
            this.getPayerContractPeriods(false);
            this.onSaveSuccessAlert(saveMessage);
            this.loadOptions();
            this.previousContractPeriod = this.currentContractPeriod;
            if (saveRate) {
              this.onRatesSaved.emit();
            }
          },
          (error) => {
            spinner.dismiss();
            this.showError(error);
          }
        );
    } else {
      this.currentContractPeriod = this.emptyContractPeriod();
      this.contractPeriodsOptions = [];
      this.loadOptions();
      this.showAlert({
        title: "Error",
        message:
          "Payer general information needs to be saved before adding a new contract period.",
      });
    }
  }

  showError = (error) => {
    if (error instanceof HttpErrorResponse) {
      if (error.error) {
        this.showAlert({
          title: "Error",
          message: "Error while saving rates: " + error.error,
        });
      } else {
        this.showAlert({
          title: "Error",
          message: "Error while saving rates: " + error.message,
        });
      }
    }
  };

  showAlert = ({ title, message }) => {
    let alert = this.alertCtrl.create({
      title,
      message,
      buttons: [
        {
          text: "Ok",
          handler: () => {},
        },
      ],
    });
    alert.present();
  };

  mapNewPalliativeVisitRate(rates, start, end) {
    let newVisitRates: PalliativeVisitPayerRates = {
      payerId: this.currentPayer ? this.currentPayer.payerId : null,
      benefitType: "PALLIATIVE",
      benefitSubtype: null,
      payerType: this.currentPayer
        ? this.currentPayer.payerType.toUpperCase()
        : null,
      rates: rates,
      start: start,
      end: end,
      localityCode: this.selectedCountyData.code,
    };
    return newVisitRates;
  }

  private onSaveSuccessAlert = (message: string) => {
    this.showAlert({
      title: "Success",
      message: message,
    });

    this.hasUnsavedChanges = false;
    this._saveEnabled = false;
  };

  getEffectiveDate() {
    return this.currentContractPeriod &&
      this.currentContractPeriod.effectiveDate
      ? this.formatDate(this.currentContractPeriod.effectiveDate)
      : "";
  }

  getExpiredDate() {
    return this.currentContractPeriod && this.currentContractPeriod.expiredDate
      ? this.formatDate(this.currentContractPeriod.expiredDate)
      : "";
  }

  formatDate(dateString: string): string {
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);

    const formattedMonth = (date.getMonth() + 1).toString().padStart(2, "0");
    const formattedDay = date.getDate().toString().padStart(2, "0");
    const formattedYear = date.getFullYear();

    return `${formattedMonth}/${formattedDay}/${formattedYear}`;
  }

  showSavePayerModal() {
    if (this.currentContractPeriod && this.currentContractPeriod.id > 0) {
      let modalPage = this.modalCtrl.create(
        "SaveFacilityPage",
        {
          title: "Payer Information Change",
          commentPlaceholderKey: "archiveFacilityCommentPlaceHolder",
          popupMessageKey: "savePayerWarningMessage",
          section: "payer",
        },
        {
          enableBackdropDismiss: false,
          cssClass: "save-payer-confirmation-popup",
        }
      );
      modalPage.onDidDismiss((data) => {
        if (data.save) {
          this.saveVisitRates();
        }
      });
      modalPage.present();
    } else {
      this.saveVisitRates();
    }
  }

  async onStateChange(selectedState: string): Promise<void> {
    if (!this.hasUnsavedChanges) {
      this.lastSelectedState = this.selectedState;
      this.selectedState = selectedState;
      this.selectedCounty = "";
      this.selectedCountyData = null;
      this.currentContractPeriod = this.emptyContractPeriod();
      this.loadCountiesFromBackend(this.selectedState);
      this.clearContractPeriodRates();
      this.updateSaveEnabledForRates();
      return;
    }

    this.lastSelectedState = this.selectedState;

    try {
      await this.confirmDiscardChanges(
        () => {
          this.selectedState = selectedState;
          this.selectedCounty = "";
          this.selectedCountyData = null;
          this.currentContractPeriod = this.emptyContractPeriod();
          this.loadCountiesFromBackend(this.selectedState);
          this.clearContractPeriodRates();
          this.updateSaveEnabledForRates();
          this.cdr.detectChanges();
        },
        () => {
          this.selectedState = this.lastSelectedState;
          this.selectedCountyData = this.getCountyByCode(
            this.selectedState,
            this.selectedCounty
          );
          this.forceStateUpdate();
        }
      );
    } catch (error) {
      this.selectedState = selectedState;
      this.selectedCounty = "";
      this.selectedCountyData = null;
      this.currentContractPeriod = this.emptyContractPeriod();
      this.loadCountiesFromBackend(this.selectedState);
      this.clearContractPeriodRates();
      this.updateSaveEnabledForRates();
    }
  }

  async onCountyChange(selectedCounty: string): Promise<void> {
    if (!this.hasUnsavedChanges) {
      this.lastSelectedCounty = this.selectedCounty;
      this.selectedCounty = selectedCounty;
      this.selectedCountyData = this.getCountyByCode(
        this.selectedState,
        this.selectedCounty
      );
      this.currentContractPeriod = this.emptyContractPeriod();
      this.clearContractPeriodRates();
      this.setRatesDisabledToEdit();
      this.updateSaveEnabledForRates();
      this.getPayerContractPeriods(false);
      return;
    }

    this.lastSelectedCounty = this.selectedCounty;

    try {
      await this.confirmDiscardChanges(
        () => {
          this.selectedCounty = selectedCounty;
          this.selectedCountyData = this.getCountyByCode(
            this.selectedState,
            this.selectedCounty
          );
          this.currentContractPeriod = this.emptyContractPeriod();
          this.clearContractPeriodRates();
          this.setRatesDisabledToEdit();
          this.updateSaveEnabledForRates();
          this.getPayerContractPeriods(false);
          this.cdr.detectChanges();
        },
        () => {
          this.selectedCounty = this.lastSelectedCounty;
          this.selectedCountyData = this.getCountyByCode(
            this.selectedState,
            this.selectedCounty
          );
          this.forceCountyUpdate();
        }
      );
    } catch (error) {
      this.selectedCounty = selectedCounty;
      this.selectedCountyData = this.getCountyByCode(
        this.selectedState,
        this.selectedCounty
      );
      this.currentContractPeriod = this.emptyContractPeriod();
      this.clearContractPeriodRates();
      this.setRatesDisabledToEdit();
      this.updateSaveEnabledForRates();
      this.getPayerContractPeriods(false);
    }
  }

  onStateChangeProceed(): void {
    this.selectedCounty = "";
    this.selectedCountyData = null;
    this.currentContractPeriod = this.emptyContractPeriod();
    this.loadCountiesFromBackend(this.selectedState);
    this.clearContractPeriodRates();
    this.updateSaveEnabledForRates();
  }

  onCountyChangeProceed(): void {
    this.selectedCountyData = this.getCountyByCode(
      this.selectedState,
      this.selectedCounty
    );
    this.currentContractPeriod = this.emptyContractPeriod();
    this.clearContractPeriodRates();
    this.setRatesDisabledToEdit();
    this.updateSaveEnabledForRates();
    this.getPayerContractPeriods(false);
  }

  loadRatesForSelectedCounty(): void {
    if (
      this.selectedState &&
      this.selectedCounty &&
      this.currentContractPeriod
    ) {
      let spinnerText = "Loading Rates for Selected County";

      const spinner = this.loadingCtrl.create({
        content: spinnerText,
      });
      spinner.present();
      const countyData = this.getCountyByCode(
        this.selectedState,
        this.selectedCounty
      );

      if (countyData && countyData.code) {
        this.payersService
          .getPayerRatesWithLocality(
            this.currentPayer.payerId,
            "PALLIATIVE",
            this.currentContractPeriod.effectiveDate,
            this.currentPayer.payerType.toUpperCase(),
            countyData.code,
            null
          )
          .pipe()
          .take(1)
          .subscribe(
            (response) => {
              spinner.dismiss();
              this.clearContractPeriodRates();
              this.mapContractPeriodRates(response);
              this.hasUnsavedChanges = false;
              this.updateSaveEnabledForRates();
            },
            (error) => {
              spinner.dismiss();
              this.clearContractPeriodRates();
              this.hasUnsavedChanges = false;
              this.updateSaveEnabledForRates();
              this.showError(error);
            }
          );
      } else {
        spinner.dismiss();
        this.clearContractPeriodRates();
        this.hasUnsavedChanges = false;
        this.updateSaveEnabledForRates();
      }
    }
  }

  getStateInitial(stateName: string): string {
    const stateInitials: { [key: string]: string } = {
      Alabama: "AL",
      Alaska: "AK",
      Arizona: "AZ",
      Arkansas: "AR",
      California: "CA",
      Colorado: "CO",
      Connecticut: "CT",
      Delaware: "DE",
      "District of Columbia": "DC",
      Florida: "FL",
      Georgia: "GA",
      "Hawaii/Guam": "HI",
      Idaho: "ID",
      Illinois: "IL",
      Indiana: "IN",
      Iowa: "IA",
      Kansas: "KS",
      Kentucky: "KY",
      Louisiana: "LA",
      Maine: "ME",
      Maryland: "MD",
      Massachusetts: "MA",
      Michigan: "MI",
      Minnesota: "MN",
      Mississippi: "MS",
      Missouri: "MO",
      Montana: "MT",
      Nebraska: "NE",
      Nevada: "NV",
      "New Hampshire": "NH",
      "New Jersey": "NJ",
      "New Mexico": "NM",
      "New York": "NY",
      "North Carolina": "NC",
      "North Dakota": "ND",
      Ohio: "OH",
      Oklahoma: "OK",
      Oregon: "OR",
      Pennsylvania: "PA",
      "Puerto Rico": "PR",
      "Rhode Island": "RI",
      "South Carolina": "SC",
      "South Dakota": "SD",
      Tennessee: "TN",
      Texas: "TX",
      Utah: "UT",
      Vermont: "VT",
      "Virgin Islands": "VI",
      Virginia: "VA",
      Washington: "WA",
      "West Virginia": "WV",
      Wisconsin: "WI",
      Wyoming: "WY",
    };
    return stateInitials[stateName] || stateName;
  }

  loadCountiesFromBackend(stateName: string): void {
    const stateInitial = this.getStateInitial(stateName);

    this.payersService
      .getLocationByState(stateInitial)
      .pipe()
      .take(1)
      .subscribe(
        (response: any) => {
          if (response && response.length > 0) {
            this.counties = [];
            for (let i = 0; i < response.length; i++) {
              const item = response[i];
              this.counties.push({
                name: item.locationName || "",
                code: item.locationCode || "",
              });
            }
          } else {
            this.counties = [];
          }
        },
        (error) => {
          this.counties = [];
        }
      );
  }

  getCountyByCode(state: string, countyCode: string): CountyData | null {
    for (let i = 0; i < this.counties.length; i++) {
      if (this.counties[i].code === countyCode) {
        return this.counties[i];
      }
    }
    return null;
  }

  countySearch = (term: string, item: CountyData) => {
    if (!term) return true;
    const t = term.toLowerCase();
    return (
      (item.name && item.name.toLowerCase().indexOf(t) !== -1) ||
      (item.code && item.code.toLowerCase().indexOf(t) !== -1)
    );
  };

  isLongCountySelected(): boolean {
    if (!this.selectedCountyData) return false;
    const label = `${this.selectedCountyData.name}`.trim();
    return label.length > 40;
  }

  getCountySelectStyle() {
    if (window.innerWidth < 768) {
      return {};
    }

    const base = 280;
    const perChar = 7;
    let len = 0;
    if (this.selectedCountyData) {
      const label = `${this.selectedCountyData.name} - ${
        this.selectedCountyData.code || ""
      }`;
      len = label.length;
    }

    if (len <= 25) {
      return {};
    }

    const dynamicWidth = Math.max(base, base + (len - 25) * perChar);
    const viewportWidth = window.innerWidth;
    const availableWidth = viewportWidth * 0.3;
    const finalWidth = Math.min(dynamicWidth, availableWidth, 600);

    return {
      "width.px": finalWidth,
      "min-width": "200px",
    };
  }

  private async confirmDiscardChanges(
    onProceed: () => void,
    onCancel: () => void
  ) {
    const alert = await this.alertCtrl.create({
      title: "Unsaved Changes",
      message:
        "Changes have not been saved, proceeding will discard changes made",
      enableBackdropDismiss: false,
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          handler: () => {
            onCancel();
          },
        },
        {
          text: "Proceed",
          handler: () => {
            onProceed();
          },
        },
      ],
    });
    await alert.present();
  }

  private forceNgSelectUpdate() {
    this.cdr.detectChanges();
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 50);
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 150);
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 300);
  }

  private forceStateUpdate() {
    if (this.stateSelect) {
      this.stateSelect.clearModel();
      setTimeout(() => {
        this.stateSelect.writeValue(this.selectedState);
        this.cdr.detectChanges();
      }, 10);
    } else {
      const currentState = this.selectedState;
      this.selectedState = "";
      setTimeout(() => {
        this.selectedState = currentState;
        this.cdr.detectChanges();
      }, 10);
    }
  }

  private forceCountyUpdate() {
    if (this.countySelect) {
      this.countySelect.clearModel();
      setTimeout(() => {
        this.countySelect.writeValue(this.selectedCounty);
        this.cdr.detectChanges();
      }, 10);
    } else {
      const currentCounty = this.selectedCounty;
      this.selectedCounty = "";
      setTimeout(() => {
        this.selectedCounty = currentCounty;
        this.cdr.detectChanges();
      }, 10);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/payers/rates-payer/palliative-visits/palliative-visits.ts